<template>
    <div class="third">
        <component
            :is="labelName"
            :ref="labelName"
            :IDlist="IDlist"
            :type="type"
            @ReasonsFoRreporting="GOReasonsFoRreporting"
            @toDetails="toDetails"
            @backHome="goBackHome"
        ></component>
    </div>
</template>

<script>
import ReportingManagementIndex from "./reportComponents/ReportingManagementIndex";
import ReasonsFoRreporting from "./reportComponents/ReasonsFoRreporting";
import ReportingDetails from "./reportComponents/details";
export default {
    name: "sensitiveWordIndex",
    data() {
        return {
            labelName: "ReportingManagementIndex",
            IDlist: {},
            type: 1, // 1详情 2昵称
        };
    },
    components: {
        ReportingManagementIndex,
        ReasonsFoRreporting,
        ReportingDetails,
    },
    created() {},
    methods: {
        // 返回首页
        goBackHome() {
            this.labelName = "ReportingManagementIndex";
        },
        // 详情 zou 2019年12月18日 复制详情页面到本文件目录下 以便于跳转和后期维护
        toDetails(data) {
            console.log(data)
            // 1 被举报公众号详情
            // 2 举报人详情
            // 3 详情
            this.type = data.type;
            sessionStorage.setItem("detailsUserID", data.id);
            sessionStorage.setItem("detailsActionID", data.actionId);
            this.labelName = "ReportingDetails";
        },
        // 新增/编辑
        GOReasonsFoRreporting(val) {
            this.labelName = "ReasonsFoRreporting";
            console.log("获取", val);
            this.IDlist = val;
        }
    }
};
</script>
